import { render, staticRenderFns } from "./MnemonicPasswordModal.vue?vue&type=template&id=bf779efc&scoped=true&"
import script from "./MnemonicPasswordModal.vue?vue&type=script&lang=js&"
export * from "./MnemonicPasswordModal.vue?vue&type=script&lang=js&"
import style0 from "./MnemonicPasswordModal.vue?vue&type=style&index=0&id=bf779efc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf779efc",
  null
  
)

export default component.exports